import cn from 'classnames';

import {Button} from '@/ui/kit/ButtonLink/Button';

import s from './ErrorButton.module.css';

export type ErrorButtonProps = {
  buttonText: string;
  className?: string;
  onClick: VoidFunction;
  isDisabled?: boolean;
};

export function ErrorButton({buttonText, isDisabled, className, onClick}: ErrorButtonProps): JSX.Element | null {
  if (!buttonText) return null;

  return (
    <Button isDisabled={isDisabled} onClick={onClick} className={cn(s.button, className)}>
      {buttonText}
    </Button>
  );
}
